import type {FieldHelpDefinition} from '../../../../../../_metronic/helpers/components/FieldHelp'
import {brandName} from '../../../../../../_metronic/helpers/brand'
import type {InvoiceFieldRuleV79, InvoiceRulesV79} from './invoiceRulesV79'

type OfficialField = [path: string, title: string, example?: string]

const officialFields: OfficialField[] = [
  ['header.taxid', 'شناسه یکتای مالیاتی صورتحساب', 'A1117...'],
  ['header.indatim', 'تاریخ و زمان صدور صورتحساب', '1785601800000'],
  ['header.indati2m', 'تاریخ و زمان ثبت صورتحساب', '1785601800000'],
  ['header.inno', 'سریال داخلی صورتحساب', '100025'],
  ['header.inty', 'نوع صورتحساب', '1'],
  ['header.inp', 'الگوی صورتحساب', '1'],
  ['header.ins', 'موضوع صورتحساب', '1'],
  ['header.insr', 'قاعده ارسال صورتحساب', '1'],
  ['header.irtaxid', 'شناسه مالیاتی صورتحساب مرجع', 'A1117...'],
  ['header.tins', 'شماره اقتصادی فروشنده', '14001234567'],
  ['header.tob', 'نوع شخص خریدار', '2'],
  ['header.bid', 'شناسه ملی یا کد فراگیر خریدار', '0012345678'],
  ['header.tinb', 'شماره اقتصادی خریدار', '14001234567'],
  ['header.sbc', 'کد شعبه فروشنده', '0001'],
  ['header.bpc', 'کد پستی خریدار', '1234567890'],
  ['header.bbc', 'کد شعبه خریدار', '0001'],
  ['header.bpn', 'شماره گذرنامه خریدار', 'A12345678'],
  ['header.ft', 'نوع پرواز', '1'],
  ['header.scln', 'شماره پروانه گمرکی', '12345678901234'],
  ['header.scc', 'کد گمرک محل اظهار فروشنده', '12345'],
  ['header.cdcn', 'شماره کوتاژ اظهارنامه گمرکی', '12345678901234'],
  ['header.cdcd', 'تاریخ کوتاژ اظهارنامه گمرکی', '14050512'],
  ['header.crn', 'شناسه یکتای ثبت قرارداد پیمانکاری', '123456789012'],
  ['header.billid', 'شماره اشتراک یا شناسه قبض بهره‌بردار', '1234567890123456789'],
  ['header.asn', 'شماره اعلامیه فروش بورس', '123456789'],
  ['header.asd', 'تاریخ اعلامیه فروش بورس', '14050512'],
  ['header.in', 'شناسه یکتای بیمه‌نامه', '123456789012'],
  ['header.an', 'شناسه یکتای الحاقیه', '123456789012'],
  ['header.lno', 'شماره بارنامه', '123456789012345678'],
  ['header.lrno', 'شماره بارنامه مرجع', '123456789012345678'],
  ['header.ocu', 'کشور مبدأ', '033'],
  ['header.oci', 'شهر مبدأ', '284'],
  ['header.dco', 'کشور مقصد', '033'],
  ['header.dci', 'شهر مقصد', '12'],
  ['header.tid', 'شناسه فرستنده', '14001234567'],
  ['header.rid', 'شناسه گیرنده', '14007654321'],
  ['header.lt', 'نوع حمل یا بارنامه', '1'],
  ['header.cno', 'شماره ناوگان', 'IR123456789'],
  ['header.did', 'شناسه راننده حمل جاده‌ای', '0012345678'],
  ['header.tprdis', 'مجموع مبلغ قبل از کسر تخفیف', '1500000'],
  ['header.tdis', 'مجموع تخفیفات', '100000'],
  ['header.tadis', 'مجموع مبلغ پس از کسر تخفیف', '1400000'],
  ['header.tvam', 'مجموع مالیات بر ارزش افزوده', '140000'],
  ['header.todam', 'مجموع سایر مالیات، عوارض و وجوه قانونی', '0'],
  ['header.tbill', 'مجموع صورتحساب', '1540000'],
  ['header.setm', 'روش تسویه', '1'],
  ['header.cap', 'مبلغ پرداختی نقدی', '1540000'],
  ['header.insp', 'مبلغ نسیه', '0'],
  ['header.tvop', 'مجموع سهم مالیات بر ارزش افزوده از پرداخت', '0'],
  ['header.tax17', 'مالیات موضوع ماده ۱۷', '0'],
  ['header.torv', 'مجموع ارزش ریالی', '1540000'],
  ['header.tocv', 'مجموع ارزش ارزی', '120'],
  ['header.tonw', 'مجموع وزن خالص', '250.5'],
  ['header.nti1', 'یادداشت تکمیلی ۱', 'توضیح کوتاه'],
  ['header.nti2', 'یادداشت تکمیلی ۲', 'توضیح کوتاه'],
  ['body[].sstid', 'شناسه کالا یا خدمت', '2330001234567'],
  ['body[].sstt', 'شرح کالا یا خدمت', 'خدمات پشتیبانی'],
  ['body[].am', 'تعداد یا مقدار', '2.5'],
  ['body[].mu', 'واحد اندازه‌گیری', '1627'],
  ['body[].fee', 'مبلغ واحد', '500000'],
  ['body[].cfee', 'میزان ارز', '100'],
  ['body[].cut', 'نوع ارز', 'USD'],
  ['body[].exr', 'نرخ برابری ارز با ریال', '600000'],
  ['body[].ssrv', 'ارزش ریالی کالا', '60000000'],
  ['body[].sscv', 'ارزش ارزی کالا', '100'],
  ['body[].cpr', 'نرخ خرید ارز', '590000'],
  ['body[].sovat', 'مأخذ مالیات بر ارزش افزوده در الگوی فروش ارز', '1000000'],
  ['body[].cui', 'عیار', '750'],
  ['body[].prdis', 'مبلغ قبل از تخفیف', '1000000'],
  ['body[].dis', 'مبلغ تخفیف', '100000'],
  ['body[].adis', 'مبلغ بعد از تخفیف', '900000'],
  ['body[].vra', 'نرخ مالیات بر ارزش افزوده', '10'],
  ['body[].vam', 'مبلغ مالیات بر ارزش افزوده', '90000'],
  ['body[].odt', 'موضوع سایر مالیات و عوارض', 'عوارض قانونی'],
  ['body[].odr', 'نرخ سایر مالیات و عوارض', '2'],
  ['body[].odam', 'مبلغ سایر مالیات و عوارض', '18000'],
  ['body[].olt', 'موضوع سایر وجوه قانونی', 'وجه قانونی'],
  ['body[].olr', 'نرخ سایر وجوه قانونی', '1'],
  ['body[].olam', 'مبلغ سایر وجوه قانونی', '9000'],
  ['body[].consfee', 'اجرت ساخت', '50000'],
  ['body[].spro', 'سود فروشنده', '30000'],
  ['body[].bros', 'حق‌العمل', '20000'],
  ['body[].tcpbs', 'جمع کل اجرت، حق‌العمل و سود', '100000'],
  ['body[].vba', 'مبلغ پایه مالیات بر ارزش افزوده', '900000'],
  ['body[].tsstam', 'مبلغ کل کالا یا خدمت', '999000'],
  ['body[].bsrn', 'شماره قرارداد معامله از طریق شخص ثالث', '123456789012'],
  ['body[].nw', 'وزن خالص', '250.5'],
  ['body[].cop', 'سهم نقدی از پرداخت', '500000'],
  ['body[].vop', 'سهم مالیات بر ارزش افزوده از پرداخت', '50000'],
  ['payments[].pmt', 'روش پرداخت', '1'],
  ['payments[].trn', 'شماره پیگیری یا شماره مرجع', '12345678901234'],
  ['payments[].pcn', 'شماره کارت پرداخت‌کننده', '6037991234567890'],
  ['payments[].pid', 'شناسه پرداخت‌کننده', '0012345678'],
  ['payments[].iinn', 'شماره سوئیچ پرداخت', '123456789'],
  ['payments[].acn', 'شماره پذیرنده فروشگاهی', '12345678901234'],
  ['payments[].trmn', 'شماره پایانه', '12345678'],
  ['payments[].pdt', 'تاریخ و زمان پرداخت', '1785601800000'],
  ['payments[].pv', 'مبلغ پرداختی', '1540000'],
]

const descriptionOverrides: Record<string, string> = {
  'header.indatim':
    'تاریخ واقعی صدور صورتحساب است و برای تولید TaxId و کنترل مهلت ارسال استفاده می‌شود.',
  'header.inno':
    'شماره مسلسل داخلی صورتحساب است و باید در محدوده مالی مربوط، یکتا و قابل ردیابی باشد.',
  'header.inty':
    'مشخص می‌کند صورتحساب از نوع اول یا دوم است و قواعد اطلاعات خریدار را تعیین می‌کند.',
  'header.inp': 'الگوی قانونی صورتحساب را تعیین می‌کند و روی فیلدها و محدودیت اقلام اثر دارد.',
  'header.ins': 'موضوع صورتحساب را به‌صورت اصلی، اصلاحی، ابطالی یا برگشت از فروش مشخص می‌کند.',
  'header.irtaxid':
    'شناسه صورتحساب مرجعی است که صورتحساب اصلاحی، ابطالی یا برگشت به آن متصل می‌شود.',
  'header.tinb':
    'شماره اقتصادی خریدار برای شناسایی او و اعمال قواعد صورتحساب نوع اول استفاده می‌شود.',
  'header.setm': 'نحوه تسویه صورتحساب را به‌صورت نقدی، نسیه یا ترکیبی مشخص می‌کند.',
  'header.tbill':
    'مبلغ نهایی صورتحساب پس از تخفیف، مالیات و سایر عوارض است و توسط سامانه محاسبه می‌شود.',
  'body[].sstid': 'شناسه استاندارد کالا یا خدمت انتخاب‌شده برای این ردیف صورتحساب است.',
  'body[].sstt': 'شرح قابل نمایش کالا یا خدمت در این ردیف صورتحساب است.',
  'body[].am': 'تعداد یا مقدار کالا/خدمت است؛ قواعد اعشار و مقدار مجاز به الگو وابسته است.',
  'body[].mu': 'کد واحد اندازه‌گیری معتبر سامانه مؤدیان برای مقدار این ردیف است.',
  'body[].fee': 'قیمت یک واحد کالا یا خدمت پیش از اعمال تخفیف است.',
  'body[].dis': 'مبلغ تخفیف همان ردیف است و نباید از مبلغ قبل از تخفیف بیشتر باشد.',
  'body[].vra': 'نرخ مالیات بر ارزش افزوده قابل اعمال برای شناسه کالا/خدمت این ردیف است.',
  'body[].vam': 'مبلغ مالیات بر ارزش افزوده ردیف است و از مبنای مشمول و نرخ مالیات محاسبه می‌شود.',
  'header.ocu':
    'کد سه‌رقمی کشور مبدأ بار از جدول کدینگ کشورها (پیوست ۹-۴ دستورالعمل)؛ کد ایران در این جدول ۰۳۳ است.',
  'header.oci':
    'کد شهر مبدأ از جدول کدینگ شهرها (پیوست ۹-۵ دستورالعمل)؛ وقتی کشور مبدأ ایران است الزامی است.',
  'header.dco':
    'کد سه‌رقمی کشور مقصد بار از جدول کدینگ کشورها (پیوست ۹-۴ دستورالعمل)؛ کد ایران در این جدول ۰۳۳ است.',
  'header.dci':
    'کد شهر مقصد از جدول کدینگ شهرها (پیوست ۹-۵ دستورالعمل)؛ وقتی کشور مقصد ایران است الزامی است.',
  'payments[].pmt': 'روش انجام پرداخت این رکورد، مانند کارت، درگاه، نقد یا چک را مشخص می‌کند.',
  'payments[].trn': 'شماره پیگیری یا مرجع تراکنش برای تطبیق پرداخت با صورتحساب است.',
  'payments[].pdt': 'زمان واقعی انجام پرداخت است و در JSON به Unix milliseconds تبدیل می‌شود.',
  'payments[].pv': 'مبلغ پرداخت ثبت‌شده برای این رکورد پرداخت است.',
}

const officialDefinitions = officialFields.reduce<Record<string, FieldHelpDefinition>>(
  (result, [path, title, example]) => {
    result[path] = {
      key: path,
      title,
      description:
        descriptionOverrides[path] ||
        `مقدار «${title}» را برای این صورتحساب ثبت می‌کند؛ قواعد دقیق آن به نوع و الگوی انتخاب‌شده وابسته است.`,
      requirement:
        path.endsWith('.taxid') || path.endsWith('.tbill') ? 'calculated' : 'conditional',
      jsonPath: path,
      example,
      source: 'RC_IITP.IS_V7.9',
    }
    return result
  },
  {}
)

const appDefinitions: Record<string, FieldHelpDefinition> = {
  'section.header': {
    key: 'section.header',
    title: 'سرآمد صورتحساب',
    description:
      'اطلاعات عمومی صورتحساب، فروشنده، خریدار، تاریخ، نوع، الگو و جمع‌ها در این بخش قرار می‌گیرند.',
    requirement: 'displayOnly',
    jsonPath: 'header',
  },
  'section.body': {
    key: 'section.body',
    title: 'اقلام صورتحساب',
    description:
      'هر کالا یا خدمت یک عضو از آرایه body[] است. نمای اصلی شامل شرح، تعداد یا مقدار، مبلغ واحد، تخفیف، مالیات و عوارض و مبلغ نهایی است؛ شناسه کالا/خدمت، واحد، نرخ‌ها و اطلاعات تخصصی الگو در «جزئیات ردیف» نمایش داده می‌شوند.',
    requirement: 'displayOnly',
    jsonPath: 'body[]',
    effect:
      'افزودن یا ویرایش هر ردیف، همان اطلاعات فعلی قلم را نگه می‌دارد؛ باز و بسته کردن جزئیات فقط نحوه نمایش را تغییر می‌دهد.',
    commonError:
      'اگر ردیفی ناقص یا خارج از قواعد الگو باشد، پیام خطا نزدیک همان ردیف یا بالای جدول نمایش داده می‌شود؛ قلم را باز کرده و فیلد مشخص‌شده را اصلاح کنید.',
    source: 'RC_IITP.IS_V7.9؛ بخش body صورتحساب',
  },
  'section.payments': {
    key: 'section.payments',
    title: 'اطلاعات پرداخت و تسویه',
    description:
      'هر پرداخت یک عضو از آرایه payments[] است. روش، مبلغ، تاریخ، شماره پیگیری یا مرجع و وضعیت در نمای اصلی دیده می‌شوند؛ اطلاعات سوئیچ، پذیرنده، پایانه، کارت و پرداخت‌کننده فقط در جزئیات ردیف مرتبط نمایش داده می‌شوند.',
    requirement: 'displayOnly',
    jsonPath: 'payments[]',
    effect:
      'روش تسویه کلی در header.setm ثبت می‌شود. مشاهده جزئیات یا کپی شماره مرجع هیچ تغییری در پرداخت و اطلاعات ارسالی ایجاد نمی‌کند.',
    commonError:
      'پرداختی که سهم نقدی یا مالیات آن با قواعد فعلی سازگار نباشد با وضعیت «نیازمند اصلاح» مشخص می‌شود و باید از طریق ویرایش همان ردیف اصلاح شود.',
    source: 'RC_IITP.IS_V7.9؛ بخش payments صورتحساب',
  },
  'section.documents': {
    key: 'section.documents',
    title: 'مستندات و توضیحات چاپی',
    description: 'فایل‌ها، قالب چاپ و توضیحات داخلی/چاپی سامانه در این بخش مدیریت می‌شوند.',
    requirement: 'displayOnly',
  },
  'section.confirmation': {
    key: 'section.confirmation',
    title: 'تأیید نهایی',
    description:
      'خلاصه اطلاعات را پیش از ثبت نهایی نمایش می‌دهد و مقدار مستقلی به JSON اضافه نمی‌کند.',
    requirement: 'displayOnly',
  },
  'ui.formType': {
    key: 'ui.formType',
    title: 'نوع فرم ورود اطلاعات',
    description:
      'فقط نحوه ورود اطلاعات در پنل را تغییر می‌دهد و نوع قانونی صورتحساب را عوض نمی‌کند.',
    requirement: 'optional',
  },
  'ui.environment': {
    key: 'ui.environment',
    title: 'محیط صورتحساب',
    description: 'مشخص می‌کند ارسال از حافظه مالیاتی عملیاتی یا سندباکس انجام شود.',
    requirement: 'required',
  },
  'ui.fiscalMemory': {
    key: 'ui.fiscalMemory',
    title: 'شناسه یکتای حافظه مالیاتی',
    description: 'حافظه مالیاتی و کلیدهای مرتبط با آن را برای تولید TaxId و ارسال انتخاب می‌کند.',
    requirement: 'required',
    jsonPath: 'header.taxid',
    example: 'A1117...',
  },
  'ui.printTemplate': {
    key: 'ui.printTemplate',
    title: 'قالب چاپ صورتحساب',
    description: 'قالب نمایش و چاپ داخلی صورتحساب را تعیین می‌کند و در JSON مالیاتی ارسال نمی‌شود.',
    requirement: 'optional',
  },
  'ui.attachments': {
    key: 'ui.attachments',
    title: 'مستندات و ضمائم',
    description: `فایل‌های پشتیبان صورتحساب را در ${brandName} نگهداری می‌کند و داخل JSON سازمان قرار نمی‌دهد.`,
    requirement: 'optional',
  },
  'ui.directSend': {
    key: 'ui.directSend',
    title: 'ارسال مستقیم',
    description:
      'تعیین می‌کند صورتحساب پس از ثبت، مستقیماً وارد فرآیند ارسال به سامانه مؤدیان شود یا خیر.',
    requirement: 'optional',
  },
  'ui.buyerDescription': {
    key: 'ui.buyerDescription',
    title: 'توضیحات خریدار',
    description: 'توضیح نمایشی مربوط به خریدار است و در JSON مالیاتی مسیر مستقلی ندارد.',
    requirement: 'optional',
  },
  'ui.invoiceDescription': {
    key: 'ui.invoiceDescription',
    title: 'سایر توضیحات صورتحساب',
    description: 'برای نمایش توضیح تکمیلی در نسخه چاپی صورتحساب استفاده می‌شود.',
    requirement: 'optional',
  },
  'ui.posTransaction': {
    key: 'ui.posTransaction',
    title: 'تراکنش کارت‌خوان مرتبط',
    description:
      'یک تراکنش آزاد را به پرداخت صورتحساب متصل می‌کند و اطلاعات آن در payments[] نگاشت می‌شود.',
    requirement: 'optional',
    jsonPath: 'payments[]',
  },
  'ui.customerSearch': {
    key: 'ui.customerSearch',
    title: 'جستجوی خریدار',
    description: `برای یافتن خریدار ذخیره‌شده در ${brandName} استفاده می‌شود و مقدار مستقیمی در JSON ندارد.`,
    requirement: 'optional',
  },
  'ui.discountDescription': {
    key: 'ui.discountDescription',
    title: 'شرح تخفیف',
    description: 'توضیح داخلی تخفیف است؛ مبلغ نهایی تخفیف در body[].dis ارسال می‌شود.',
    requirement: 'optional',
    jsonPath: 'body[].dis',
  },
  'ui.vatRateCheck': {
    key: 'ui.vatRateCheck',
    title: 'کنترل نرخ مالیات بر ارزش افزوده',
    description:
      'مشخص می‌کند نرخ‌های واردشده پیش از ثبت با نرخ مرجع شناسه کالا/خدمت کنترل شوند یا خیر؛ این انتخاب در JSON مالیاتی فیلد مستقلی ندارد.',
    requirement: 'optional',
  },
  'ui.referenceFile': {
    key: 'ui.referenceFile',
    title: 'فایل خروجی کارپوشه',
    description:
      'برای یافتن صورتحساب مرجع از خروجی کارپوشه استفاده می‌شود و خود فایل داخل JSON مالیاتی ارسال نمی‌شود.',
    requirement: 'optional',
  },
  'ui.referenceSearch': {
    key: 'ui.referenceSearch',
    title: 'جستجوی صورتحساب مرجع',
    description:
      'نتایج فایل کارپوشه را برای انتخاب شناسه مالیاتی مرجع فیلتر می‌کند و مقدار مستقلی در JSON ندارد.',
    requirement: 'optional',
    jsonPath: 'header.irtaxid',
  },
}

const normalize = (value: string) =>
  value
    .replace(/[يى]/g, 'ی')
    .replace(/ك/g, 'ک')
    .replace(/\u200c/g, ' ')
    .replace(/\(اختیاری\)/g, '')
    .replace(/[«»(){}:؛،,.!?؟*/]/g, ' ')
    .replace(/\[|\]/g, ' ')
    .replace(/\s+/g, ' ')
    .trim()

const aliases: Array<[alias: string, key: string]> = [
  ['سرآمد صورتحساب', 'section.header'],
  ['سرآمد صورتحساب', 'section.header'],
  ['اطلاعات صورتحساب', 'section.header'],
  ['اقلام صورتحساب', 'section.body'],
  ['اقلام صورتحساب', 'section.body'],
  ['سرجمع صورتحساب', 'section.body'],
  ['روش تسویه', 'section.payments'],
  ['نحوه تسویه', 'header.setm'],
  ['اطلاعات پرداخت', 'section.payments'],
  ['مستندات', 'section.documents'],
  ['اطلاعات اختیاری', 'section.documents'],
  ['تایید', 'section.confirmation'],
  ['تأیید', 'section.confirmation'],
  ['نوع فرم', 'ui.formType'],
  ['محیط صورتحساب', 'ui.environment'],
  ['شناسه حافظه مالیاتی', 'ui.fiscalMemory'],
  ['شناسه یکتای حافظه مالیاتی', 'ui.fiscalMemory'],
  ['قالب صورتحساب چاپی خود را تعیین کنید', 'ui.printTemplate'],
  ['مستندات و ضمائم', 'ui.attachments'],
  ['ارسال مستقیم صورتحساب', 'ui.directSend'],
  ['توضیحات در باکس خریدار', 'ui.buyerDescription'],
  ['توضیحات خریدار', 'ui.buyerDescription'],
  ['سایر توضیحات صورتحساب', 'ui.invoiceDescription'],
  ['تراکنش کارت‌خوان مرتبط', 'ui.posTransaction'],
  ['شرح تخفیف', 'ui.discountDescription'],
  ['کنترل نرخ مالیات بر ارزش افزوده', 'ui.vatRateCheck'],
  ['انتخاب کالا خدمت', 'body[].sstid'],
  ['ماخذ مالیات بر ارزش افزوده در الگوی فروش ارز', 'body[].sovat'],
  ['فایل خروجی کارپوشه', 'ui.referenceFile'],
  ['جستجوی صورتحساب مرجع', 'ui.referenceSearch'],
  ['شماره مسلسل', 'header.inno'],
  ['شماره صورتحساب', 'header.inno'],
  ['تاریخ صورتحساب', 'header.indatim'],
  ['تاریخ صدور', 'header.indatim'],
  ['نوع صورتحساب', 'header.inty'],
  ['موضوع صورتحساب', 'header.ins'],
  ['خریدار صورتحساب', 'header.tinb'],
  ['خریدار', 'header.tinb'],
  ['شماره ملی مسافر', 'header.bid'],
  ['کد فراگیر اتباع غیرایرانی مسافر', 'header.bid'],
  ['شماره گذرنامه مسافر', 'header.bpn'],
  ['شماره اقتصادی خریدار بلیط', 'header.tinb'],
  ['نام مسافر', 'body[].sstt'],
  ['نام خانوادگی مسافر', 'body[].sstt'],
  ['نام آژانس فروش', 'header.tinc'],
  ['شماره اقتصادی آژانس', 'header.tinc'],
  ['کشور مبدا', 'header.ocu'],
  ['شهر مبدا', 'header.oci'],
  ['کشور مقصد', 'header.dco'],
  ['شهر مقصد', 'header.dci'],
  ['مجموع وزن بارنامه', 'header.tonw'],
  ['کالا خدمت', 'body[].sstid'],
  ['شرح کالا خدمت در صورتحساب', 'body[].sstt'],
  ['تعداد مقدار', 'body[].am'],
  ['تعداد / مقدار', 'body[].am'],
  ['قیمت واحد', 'body[].fee'],
  ['قیمت پایه', 'body[].fee'],
  ['قیمت تمام شده', 'body[].fee'],
  ['مبلغ نهایی را وارد کنید', 'body[].tsstam'],
  ['مبلغ نهایی فروش', 'body[].tsstam'],
  ['جمع کل کالا خدمت نهایی', 'body[].tsstam'],
  ['تعداد ارقام اعشار میزان', 'body[].am'],
  ['درصد اجرت ساخت', 'body[].consfee'],
  ['درصد سود فروشنده', 'body[].spro'],
  ['درصد حق العمل', 'body[].bros'],
  ['مظنه یک مثقال طلا', 'body[].fee'],
  ['ضریب تبدیل قیمت مثقال به گرم', 'body[].fee'],
  ['قیمت یک گرم طلا', 'body[].fee'],
  ['جمع قبل از تخفیف', 'header.tprdis'],
  ['جمع تخفیف', 'header.tdis'],
  ['جمع بعد از تخفیف', 'header.tadis'],
  ['مجموع مالیات بر ارزش افزوده', 'header.tvam'],
  ['جمع سایر مالیات ها', 'header.todam'],
  ['مجموع ارزش ریالی', 'header.torv'],
  ['مجموع ارزش ارزی', 'header.tocv'],
  ['مجموع وزن خالص', 'header.tonw'],
  ['مجموع صورتحساب', 'header.tbill'],
  ['انتخاب تراکنش کارت‌خوان', 'ui.posTransaction'],
  ['انتخاب درگاه پرداخت', 'payments[].pmt'],
  ['انتخاب حساب', 'payments[].pmt'],
  ['شماره پیگیری مرجع', 'payments[].trn'],
  ['شماره شناسه ملی کد فراگیر پرداخت کننده', 'payments[].pid'],
  ['تاریخ چک', 'payments[].pdt'],
  ['بانک صادر کننده', 'payments[].pmt'],
  ['شعبه', 'payments[].pmt'],
  ['شماره حساب', 'payments[].pmt'],
  ['نام صاحب حساب', 'payments[].pid'],
  ['شماره چک', 'payments[].trn'],
  ['شماره صیادی', 'payments[].trn'],
  ['در وجه', 'payments[].pid'],
  ['توضیحات', 'ui.invoiceDescription'],
]
  .map(([alias, key]): [alias: string, key: string] => [normalize(alias), key])
  .sort((left, right) => right[0].length - left[0].length)

const allDefinitions = {...officialDefinitions, ...appDefinitions}

const resolveInvoiceFieldHelp = (
  labelText: string,
  helpKey?: string
): FieldHelpDefinition | undefined => {
  if (helpKey && allDefinitions[helpKey]) return allDefinitions[helpKey]
  const normalizedLabel = normalize(labelText)
  if (!normalizedLabel) return undefined

  const aliasMatch = aliases.find(([alias]) => normalizedLabel.includes(alias))
  if (aliasMatch && allDefinitions[aliasMatch[1]]) return allDefinitions[aliasMatch[1]]

  const officialMatch = Object.values(officialDefinitions).find((definition) => {
    const normalizedTitle = normalize(definition.title)
    return normalizedLabel.includes(normalizedTitle) || normalizedTitle.includes(normalizedLabel)
  })
  if (officialMatch) return officialMatch

  return {
    key: `ui.${normalizedLabel}`,
    title: labelText.trim() || 'راهنمای فیلد',
    description:
      'این کنترل برای ثبت یا نمایش اطلاعات همین فرم استفاده می‌شود. اگر در الگوی انتخاب‌شده بخشی از اطلاعات مالیاتی باشد، نگاشت نهایی هنگام ارسال در سرور انجام می‌شود.',
    requirement: 'optional',
  }
}

const dataTypeLabels: Record<string, string> = {
  String: 'متن',
  NumericString: 'رشته عددی',
  Integer: 'عدد صحیح',
  Decimal: 'عدد اعشاری',
  UnixMilliseconds: 'تاریخ و زمان',
  UnixDays: 'تاریخ',
}

const rialFields = new Set([
  'fee',
  'exr',
  'ssrv',
  'cpr',
  'sovat',
  'prdis',
  'dis',
  'adis',
  'vam',
  'odam',
  'olam',
  'consfee',
  'spro',
  'bros',
  'tcpbs',
  'vba',
  'tsstam',
  'cop',
  'vop',
  'tprdis',
  'tdis',
  'tadis',
  'tvam',
  'todam',
  'tbill',
  'cap',
  'insp',
  'tvop',
  'tax17',
  'torv',
  'pv',
])
const percentFields = new Set(['vra', 'odr', 'olr'])
const quantityFields = new Set(['am'])
const weightFields = new Set(['nw', 'tonw'])
const currencyFields = new Set(['cfee', 'sscv', 'tocv'])

const getRuleUnit = (jsonName: string) => {
  if (rialFields.has(jsonName)) return 'ریال'
  if (percentFields.has(jsonName)) return 'درصد'
  if (quantityFields.has(jsonName)) return 'مطابق واحد اندازه‌گیری انتخاب‌شده'
  if (weightFields.has(jsonName)) return 'واحد وزن اعلام‌شده در الگو'
  if (currencyFields.has(jsonName)) return 'ارز انتخاب‌شده'
  return undefined
}

const getRuleFormat = (rule: InvoiceFieldRuleV79) => {
  if (rule.dataType === 'NumericString') return 'فقط رقم؛ صفرهای ابتدایی در صورت وجود حفظ می‌شوند.'
  if (rule.dataType === 'Integer') return 'عدد صحیح بدون جداکننده هزارگان در JSON'
  if (rule.dataType === 'Decimal') return 'عدد غیرمنفی با تعداد اعشار مجاز همین الگو'
  if (rule.dataType === 'UnixMilliseconds')
    return 'تاریخ انتخاب‌شده در فرم، هنگام ارسال به Unix milliseconds تبدیل می‌شود.'
  if (rule.dataType === 'UnixDays')
    return 'تاریخ انتخاب‌شده در فرم، هنگام ارسال به قالب عددی رسمی تبدیل می‌شود.'
  if (rule.dataType === 'String') return 'متن یا شناسه مطابق قالب فیلد'
  return undefined
}

const getRuleConstraints = (rule: InvoiceFieldRuleV79) => {
  const constraints: string[] = []
  if (rule.maxLength) constraints.push(`حداکثر ${rule.maxLength} نویسه یا رقم`)
  if (rule.integerDigits != null) constraints.push(`حداکثر ${rule.integerDigits} رقم صحیح`)
  if (rule.decimalDigits != null) {
    constraints.push(
      rule.decimalDigits === 0 ? 'بدون رقم اعشار' : `حداکثر ${rule.decimalDigits} رقم اعشار`
    )
  }
  return constraints
}

const requirementFromRule = (rule: InvoiceFieldRuleV79): FieldHelpDefinition['requirement'] => {
  if (rule.status === 'Required') return 'required'
  if (rule.status === 'Optional') return 'optional'
  if (rule.status === 'Calculated') return 'calculated'
  if (rule.status === 'ReadOnly' || rule.status === 'InheritedFromReference') return 'displayOnly'
  return 'conditional'
}

const getRuleCondition = (rule: InvoiceFieldRuleV79) => {
  if (rule.status === 'OutOfPattern')
    return 'در نوع، الگو یا موضوع فعلی خارج از الگو است؛ نباید مقداردهی یا در JSON ارسال شود.'
  if (rule.status === 'InheritedFromReference')
    return 'از صورتحساب مرجع دریافت می‌شود و کاربر نباید آن را تغییر دهد.'
  if (rule.status === 'Calculated')
    return 'سامانه آن را از اطلاعات مرتبط محاسبه می‌کند؛ کاربر نباید مقدار را دستی محاسبه کند.'
  if (rule.status === 'ReadOnly') return 'در وضعیت فعلی فقط‌خواندنی است و امکان ویرایش ندارد.'
  if (rule.status === 'Required')
    return 'در نوع و الگوی فعلی اجباری است و باید مقدار معتبر داشته باشد.'
  if (rule.status === 'ConditionallyRequired')
    return 'در شرایط فعلی به سایر فیلدها یا وضعیت صورتحساب وابسته است؛ هنگام نمایش باید مطابق راهنمای فرم تکمیل شود.'
  return rule.shouldSerialize
    ? 'اختیاری است؛ در صورت کاربرد و ورود مقدار معتبر، در JSON ارسال می‌شود.'
    : 'در وضعیت فعلی در JSON ارسال نمی‌شود.'
}

const getRuleFormula = (rule: InvoiceFieldRuleV79) => {
  if (!rule.formula) return undefined
  return `این مقدار به‌صورت خودکار از مقادیر مرتبط صورتحساب به‌دست می‌آید و نباید دستی محاسبه شود. قاعده سیستم: ${rule.formula}`
}

const ruleJsonPath = (rule: InvoiceFieldRuleV79) => {
  if (rule.section === 'Header') return `header.${rule.jsonName}`
  if (rule.section === 'Body') return `body[].${rule.jsonName}`
  return `payments[].${rule.jsonName}`
}

const createInvoiceFieldHelpResolver =
  (rules?: InvoiceRulesV79) =>
  (labelText: string, helpKey?: string): FieldHelpDefinition | undefined => {
    const baseDefinition = resolveInvoiceFieldHelp(labelText, helpKey)
    if (!rules?.enabled) return baseDefinition

    const requestedPath = baseDefinition?.jsonPath || helpKey
    const jsonName = requestedPath?.split('.').pop()?.replace(/\[\]/g, '')
    if (!jsonName) return baseDefinition
    const rule = rules.fields.find((field) => field.jsonName === jsonName)
    if (!rule) return baseDefinition

    const path = ruleJsonPath(rule)
    const description =
      descriptionOverrides[path] ||
      baseDefinition?.description ||
      rule.hint ||
      `مقدار «${rule.titleFa}» را مطابق قواعد نوع و الگوی فعلی صورتحساب ثبت می‌کند.`
    return {
      ...baseDefinition,
      key: path,
      title: rule.titleFa,
      description,
      requirement: requirementFromRule(rule),
      jsonPath: path,
      dataType: rule.dataType ? dataTypeLabels[rule.dataType] || rule.dataType : undefined,
      format: getRuleFormat(rule),
      unit: getRuleUnit(rule.jsonName),
      constraints: getRuleConstraints(rule),
      condition: getRuleCondition(rule),
      formula: getRuleFormula(rule),
      effect: rule.hint,
      commonError: rule.errorMessage
        ? `${rule.errorMessage} مقدار را مطابق وضعیت، نوع داده و محدودیت‌های بالا اصلاح کنید.`
        : undefined,
      source: rules.sourceDocument || rules.instructionVersion,
    }
  }

export {createInvoiceFieldHelpResolver, resolveInvoiceFieldHelp}
